// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
* VARIABLES
*/
/*
* MIXINS
*/
.Navbar {
  position: fixed;
  box-sizing: border-box;
  z-index: 10;
  width: 100%;
  height: 70px;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 4vw;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 10%, rgba(0, 0, 0, 0));
  transition: all 0.2s ease-out;
}
.Navbar__fixed {
  background-image: none;
  background-color: #141414;
}
.Navbar__logo {
  max-width: 40px;
  width: 100%;
}
@media (min-width: 600px) {
  .Navbar__logo {
    max-width: 130px;
  }
}
.Navbar__primarynav, .Navbar__secondarynav {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}
.Navbar__navlinks {
  margin-left: 2rem;
}
.Navbar__navlinks--link {
  display: inline-block;
  margin: 0 12px;
  font-size: 14px;
  text-shadow: 2px 2px 6px rgba(3, 3, 3, 0.9);
}
@media (min-width: 640px) {
  .Navbar__navlinks--link {
    font-size: 16px;
  }
}
@media (min-width: 768px) {
  .Navbar__navlinks--link {
    font-size: 1.8vw;
  }
}
@media (min-width: 1024px) {
  .Navbar__navlinks--link {
    font-size: 1.2vw;
    text-shadow: 2px 2px 2px rgba(20, 20, 20, 0.45);
  }
}
@media (min-width: 1330px) {
  .Navbar__navlinks--link {
    font-size: 18px;
  }
}
.Navbar__navlinks--link a {
  color: #e5e5e5;
  text-decoration: none;
  cursor: pointer;
  font-weight: 400;
  will-change: font-weight;
  transition: color 0.2s ease-in-out;
}
.Navbar__navlinks--link a:hover {
  color: #b3b3b3;
}
.Navbar__navlinks--link .activeNavLink {
  color: #f2f2f2;
  font-weight: 700;
  cursor: default;
}
.Navbar__navlinks--link .activeNavLink:hover {
  color: #f2f2f2;
}
.Navbar__primarynav {
  position: absolute;
  top: 70px;
  left: 0;
  margin: 0 auto;
  width: 100%;
  height: 45px;
  justify-content: center;
  pointer-events: none;
  transition: all 0.2s ease-in-out;
}
@media (min-width: 1024px) {
  .Navbar__primarynav {
    position: relative;
    display: flex;
    align-items: center;
    min-height: 40px;
    cursor: pointer;
    width: unset;
    height: unset;
    top: unset;
    left: unset;
    margin: unset;
    margin-left: 2rem;
    pointer-events: all;
  }
}
.Navbar__primarynav--scrolled {
  background-color: #141414;
}
.Navbar__primarynav.active .Navbar__primarynav--caret {
  transform: rotate(180deg);
}
.Navbar__primarynav .Navbar__navlinks--link {
  pointer-events: all;
  cursor: pointer;
}
.Navbar__primarynav--caret {
  pointer-events: all;
  cursor: pointer;
  transition: transform 0.2s ease-out;
}
.Navbar__primarynav--content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.65);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(10px);
  opacity: 0;
  transition: all 0.2s ease-out;
}
@media (min-width: 640px) {
  .Navbar__primarynav--content {
    min-width: 180px;
  }
}
@media (min-width: 1024px) {
  .Navbar__primarynav--content {
    display: block;
    pointer-events: none;
    position: absolute;
    opacity: 0;
    top: 100px;
    right: 0;
    padding: 10px 0;
    min-width: auto;
    white-space: nowrap;
    border: 1px solid rgba(255, 255, 255, 0.5);
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  }
}
.Navbar__primarynav--content.active {
  opacity: 1;
  pointer-events: all;
}
.Navbar__primarynav--content li {
  color: #e5e5e5;
  padding: 4vw 0;
  text-decoration: none;
  display: block;
  cursor: pointer;
  transition: color 0.2s ease-in-out;
}
.Navbar__primarynav--content li:hover {
  color: #b3b3b3;
}
.Navbar__primarynav--content li a {
  display: block;
}
@media (min-width: 1024px) {
  .Navbar__primarynav--content li {
    padding: 5px 15px;
  }
}
.Navbar__primarynav--content .activeNavLink {
  color: #f2f2f2;
  font-weight: 700;
  cursor: default;
}
.Navbar__primarynav--content .activeNavLink:hover {
  color: #f2f2f2;
}
.Navbar__primarynav--content-wrp {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: inherit;
  height: inherit;
}
.Navbar__primarynav--content-wrp .Navbar__navlinks--link {
  font-size: 16px;
}
@media (min-width: 768px) {
  .Navbar__primarynav--content-wrp .Navbar__navlinks--link {
    font-size: 1.8vw;
  }
}
@media (min-width: 1024px) {
  .Navbar__primarynav--content-wrp .Navbar__navlinks--link {
    font-size: 1.2vw;
  }
}
.Navbar__secondarynav {
  margin-left: auto;
}
.Navbar__navprofile {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.Navbar__navprofile.active .Navbar__navprofile--caret {
  transform: rotate(180deg);
}
.Navbar__navprofile--avatar {
  max-width: 30px;
  width: 100%;
  margin-right: 8px;
}
@media (min-width: 640px) {
  .Navbar__navprofile--avatar {
    max-width: 40px;
  }
}
.Navbar__navprofile--caret {
  transition: transform 0.2s ease-out;
}
.Navbar__navprofile--content {
  display: block;
  pointer-events: none;
  position: absolute;
  opacity: 0;
  top: 100px;
  right: 0;
  padding: 10px 0;
  min-width: auto;
  white-space: nowrap;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background-color: rgba(0, 0, 0, 0.9);
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  z-index: 1;
  transition: all 0.2s ease-out;
}
@media (min-width: 640px) {
  .Navbar__navprofile--content {
    min-width: 180px;
  }
}
.Navbar__navprofile--content.active {
  opacity: 1;
  top: 55px;
  pointer-events: all;
}
.Navbar__navprofile--content li {
  color: #f2f2f2;
  padding: 5px 15px;
  text-decoration: none;
  display: block;
}
.Navbar__navprofile--content li:hover {
  text-decoration: underline;
}
.Navbar__navprofile--content li a {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/scss/_mixin.scss","webpack://./src/components/Navbar/navbar.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AAAA;;CAAA;AAKA;;CAAA;ACFA;EACI,eAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;EACA,sFAAA;EACA,6BAAA;AAIJ;AAFI;EACI,sBAAA;EACA,yBChBA;ADoBR;AADI;EACI,eAAA;EACA,WAAA;AAGR;ADiDQ;ECtDJ;IAKQ,gBAAA;EAIV;AACF;AADI;EAEI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;AAER;AACI;EACI,iBAAA;AACR;AACQ;EACI,qBAAA;EACA,cAAA;EACA,eAAA;EACA,2CAAA;AACZ;AD6BQ;EClCA;IAOQ,eAAA;EAEd;AACF;ADwBQ;EClCA;IAUQ,gBAAA;EAId;AACF;ADmBQ;EClCA;IAaQ,gBAAA;IACA,+CAAA;EAMd;AACF;ADaQ;EClCA;IAiBQ,eAAA;EAQd;AACF;AANY;EACI,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,kCAAA;AAQhB;AANgB;EACI,cAAA;AAQpB;AAJY;EACI,cC5ER;ED6EQ,gBAAA;EACA,eAAA;AAMhB;AAJgB;EACI,cCjFZ;ADuFR;AAAI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,gCAAA;AAER;ADtBQ;ECWJ;IAYQ,kBAAA;IACA,aAAA;IACA,mBAAA;IACA,gBAAA;IACA,eAAA;IACA,YAAA;IACA,aAAA;IACA,UAAA;IACA,WAAA;IACA,aAAA;IACA,iBAAA;IACA,mBAAA;EAGV;AACF;AADQ;EACI,yBC/GJ;ADkHR;AACY;EACI,yBAAA;AAChB;AAGQ;EACI,mBAAA;EACA,eAAA;AADZ;AAIQ;EACI,mBAAA;EACA,eAAA;EACA,mCAAA;AAFZ;AAKQ;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,qCAAA;EACA,gDAAA;EACA,2BAAA;EACA,UAAA;EACA,6BAAA;AAHZ;ADvEQ;EC0DA;IAmBQ,gBAAA;EAFd;AACF;AD5EQ;EC0DA;IAuBQ,cAAA;IACA,oBAAA;IACA,kBAAA;IACA,UAAA;IACA,UAAA;IACA,QAAA;IACA,eAAA;IACA,eAAA;IACA,mBAAA;IACA,0CAAA;IACA,2CAAA;EADd;AACF;AAGY;EACI,UAAA;EACA,mBAAA;AADhB;AAIY;EACI,cAAA;EACA,cAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,kCAAA;AAFhB;AAIgB;EACI,cAAA;AAFpB;AAKgB;EACI,cAAA;AAHpB;AD7GQ;ECmGI;IAiBQ,iBAAA;EAHlB;AACF;AAMY;EACI,cCrMR;EDsMQ,gBAAA;EACA,eAAA;AAJhB;AAMgB;EACI,cC1MZ;ADsMR;AAQY;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AANhB;AAQgB;EACI,eAAA;AANpB;ADpIQ;ECyIQ;IAIQ,gBAAA;EALtB;AACF;ADzIQ;ECyIQ;IAOQ,gBAAA;EAHtB;AACF;AASI;EACI,iBAAA;AAPR;AAUI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AARR;AAWY;EACI,yBAAA;AAThB;AAaQ;EACI,eAAA;EACA,WAAA;EACA,iBAAA;AAXZ;AD/JQ;ECuKA;IAMQ,eAAA;EAVd;AACF;AAaQ;EACI,mCAAA;AAXZ;AAcQ;EACI,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,oCAAA;EACA,2CAAA;EACA,UAAA;EACA,6BAAA;AAZZ;ADvLQ;ECqLA;IAiBQ,gBAAA;EAXd;AACF;AAaY;EACI,UAAA;EACA,SAAA;EACA,mBAAA;AAXhB;AAcY;EACI,cC5RR;ED6RQ,iBAAA;EACA,qBAAA;EACA,cAAA;AAZhB;AAcgB;EACI,0BAAA;AAZpB;AAcgB;EACI,cAAA;AAZpB","sourcesContent":["/*\n* VARIABLES\n*/\n$breakpoints: (ll: 1450px, lg: 1024px, md: 768px, sm: 640px, xs: 400px) !default;\n\n/*\n* MIXINS\n*/\n@mixin mq($min: null, $max: null) {\n    $min-type: type-of($min);\n    $max-type: type-of($max);\n\n    @if $min-type==string {\n        @if $min==xs {\n            $min: \"(min-width: #{map-get($breakpoints, xs)})\";\n        }\n        @else if $min==sm {\n            $min: \"(min-width: #{map-get($breakpoints, sm)})\";\n        }\n        @else if $min==md {\n            $min: \"(min-width: #{map-get($breakpoints, md)})\";\n        }\n        @else if $min==lg {\n            $min: \"(min-width: #{map-get($breakpoints, lg)})\";\n        }\n        @else if $min==ll {\n            $min: \"(min-width: #{map-get($breakpoints, ll)})\";\n        }\n        @else {\n            @warn \"mq mixin supports: sm, md, lg, ll\";\n        }\n    }\n    @else if $min-type==number {\n        $min: \"(min-width: #{$min})\";\n    }\n\n    @if $max-type==string {\n        @if $max==xs {\n            $max: \"(max-width: #{map-get($breakpoints, xs) - 1})\";\n        }\n        @else if $max==sm {\n            $max: \"(max-width: #{map-get($breakpoints, sm) - 1})\";\n        }\n        @else if $max==md {\n            $max: \"(max-width: #{map-get($breakpoints, md) - 1})\";\n        }\n        @else if $max==lg {\n            $max: \"(max-width: #{map-get($breakpoints, lg) - 1})\";\n        }\n        @else if $max==ll {\n            $max: \"(max-width: #{map-get($breakpoints, ll) - 1})\";\n        }\n        @else {\n            @warn \"mq mixin supports: xs, sm, md, lg, ll\";\n        }\n    }\n\n    @else if $max-type==number {\n        $max: \"(max-width: #{$max})\";\n    }\n\n    $query: false;\n    @if $min and $max {\n        $query: \"#{$min} and #{$max}\";\n    }\n    @else if $min {\n        $query: \"#{$min}\";\n    }\n    @else if $max {\n        $query: \"#{$max}\";\n    }\n\n    @if (not $query) {\n        @warn \"Invalid media query\";\n    }\n    @else {\n        @media #{$query} {\n            @content;\n        }\n    }\n}\n\n@mixin mob() {\n    @include mq(null, md) {\n        @content;\n    }\n}\n\n@mixin smart() {\n    @include mq(null, sm) {\n        @content;\n    }\n}\n\n@mixin tab-portrait() {\n    @include mq(sm, md) {\n        @content;\n    }\n}\n\n@mixin tab-landscape() {\n    @include mq(md, lg) {\n        @content;\n    }\n}\n\n@mixin desk() {\n    @include mq(lg) {\n        @content;\n    }\n}","@import '../../scss/mixin';\n@import '../../scss/variables';\n\n.Navbar {\n    position: fixed;\n    box-sizing: border-box;\n    z-index: 10;\n    width: 100%;\n    height: 70px;\n    top: 0;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 0 4vw;\n    background-image: linear-gradient(to bottom,rgba(0,0,0,.7) 10%,rgba(0,0,0,0));\n    transition: all 0.2s ease-out;\n\n    &__fixed {\n        background-image: none;\n        background-color: $black;\n    }\n\n    &__logo {\n        max-width: 40px;\n        width: 100%;\n\n        @include mq(600px) {\n            max-width: 130px;\n        }\n    }\n\n    &__primarynav,\n    &__secondarynav {\n        display: flex;\n        align-items: center;\n        margin: 0;\n        padding: 0;\n    }\n    \n    &__navlinks {\n        margin-left: 2rem;\n        \n        &--link {\n            display: inline-block;\n            margin: 0 12px;\n            font-size: 14px;\n            text-shadow: 2px 2px 6px rgba($color: $pure-black, $alpha: 0.9);\n\n            @include mq('sm'){\n                font-size: 16px;\n            }\n            @include mq('md'){\n                font-size: 1.8vw;\n            }\n            @include mq('lg'){\n                font-size: 1.2vw;\n                text-shadow: 2px 2px 2px rgba($color: $black, $alpha: 0.45);\n            }\n            @include mq(1330px){\n                font-size: 18px;\n            }\n            \n            a {\n                color: #e5e5e5;\n                text-decoration: none;\n                cursor: pointer;\n                font-weight: 400;\n                will-change: font-weight;\n                transition: color .2s ease-in-out;\n\n                &:hover {\n                    color: #b3b3b3;\n                }\n            }\n\n            .activeNavLink {\n                color: $white;\n                font-weight: 700;\n                cursor: default;\n\n                &:hover {\n                    color: $white;\n                }\n            }\n        }\n    }\n\n    &__primarynav {\n        position: absolute;\n        top: 70px;\n        left: 0;\n        margin: 0 auto;\n        width: 100%;\n        height: 45px;\n        justify-content: center;\n        pointer-events: none;\n        transition: all 0.2s ease-in-out;\n\n        @include mq(lg) {\n            position: relative;\n            display: flex;\n            align-items: center;\n            min-height: 40px;\n            cursor: pointer;\n            width: unset;\n            height: unset;\n            top: unset;\n            left: unset;\n            margin: unset;\n            margin-left: 2rem;\n            pointer-events: all;\n        }\n\n        &--scrolled {\n            background-color: $black;\n        }\n\n        &.active {\n            .Navbar__primarynav--caret {\n                transform: rotate(180deg);\n            }\n        }\n\n        .Navbar__navlinks--link {\n            pointer-events: all;\n            cursor: pointer;\n        }\n\n        &--caret {\n            pointer-events: all;\n            cursor: pointer;\n            transition: transform 0.2s ease-out;\n        }\n\n        &--content {\n            position: fixed;\n            top: 0;\n            left: 0;\n            width: 100vw;\n            height: 100vh;\n            border: none;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            text-align: center;\n            z-index: 1;\n            background-color: rgba(0, 0, 0, 0.65);\n            box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);\n            backdrop-filter: blur(10px);\n            opacity: 0;\n            transition: all 0.2s ease-out;\n\n            @include mq(sm) {\n                min-width: 180px;\n            }\n\n            @include mq(lg) {\n                display: block;\n                pointer-events: none;\n                position: absolute;\n                opacity: 0;\n                top: 100px;\n                right: 0;\n                padding: 10px 0;\n                min-width: auto;\n                white-space: nowrap;\n                border: 1px solid rgba(255,255,255,0.5);\n                box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n            }\n\n            &.active {\n                opacity: 1;\n                pointer-events: all;\n            }\n            \n            li {\n                color: #e5e5e5;\n                padding: 4vw 0;\n                text-decoration: none;\n                display: block;\n                cursor: pointer;\n                transition: color .2s ease-in-out;\n\n                &:hover {\n                    color: #b3b3b3;\n                }\n\n                a {\n                    display: block;\n                }\n\n                @include mq(lg) {\n                    padding: 5px 15px;\n                }\n            }\n\n            .activeNavLink {\n                color: $white;\n                font-weight: 700;\n                cursor: default;\n\n                &:hover {\n                    color: $white;\n                }\n            }\n\n            &-wrp {\n                display: flex;\n                flex-direction: column;\n                justify-content: center;\n                width: inherit;\n                height: inherit;\n\n                .Navbar__navlinks--link {\n                    font-size: 16px;\n\n                    @include mq('md') {\n                        font-size: 1.8vw;\n                    }\n                    @include mq('lg') {\n                        font-size: 1.2vw;\n                    }\n                }\n            }\n        }\n    }\n    \n    &__secondarynav {\n        margin-left: auto;\n    }\n\n    &__navprofile {\n        position: relative;\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n\n        &.active {\n            .Navbar__navprofile--caret {\n                transform: rotate(180deg);\n            }\n        }\n        \n        &--avatar {\n            max-width: 30px;\n            width: 100%;\n            margin-right: 8px;\n\n            @include mq(sm) {\n                max-width: 40px;\n            }\n        }\n\n        &--caret {\n            transition: transform 0.2s ease-out;\n        }\n\n        &--content {\n            display: block;\n            pointer-events: none;\n            position: absolute;\n            opacity: 0;\n            top: 100px;\n            right: 0;\n            padding: 10px 0;\n            min-width: auto;\n            white-space: nowrap;\n            border: 1px solid rgba(255,255,255,0.5);\n            background-color: rgba(0,0,0,0.9);\n            box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n            z-index: 1;\n            transition: all 0.2s ease-out;\n\n            @include mq(sm) {\n                min-width: 180px;\n            }\n\n            &.active {\n                opacity: 1;\n                top: 55px;\n                pointer-events: all;\n            }\n            \n            li {\n                color: $white;\n                padding: 5px 15px;\n                text-decoration: none;\n                display: block;\n        \n                &:hover {\n                    text-decoration: underline;\n                }\n                a {\n                    display: block;\n                }\n            }\n        }\n    }\n}","$white: #f2f2f2;\n$pure-black: #030303;\n$light-black: #181818;\n$black: #141414;\n$red: #e50914;\n$grey: #101011;\n$blue-google: #1356c7;\n\n$main-font: 'Inter', sans-serif;\n$fakeflix-font: 'Bebas Neue', cursive;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
